import React, { useState } from 'react';
import { Grid, Box, Typography, Button, CircularProgress } from '@material-ui/core';

const HeaderSummary = ({ classes, open, text, isUpdate, atualization, viewEmployeeRegistration, type }) => {


    return (
        <Grid container spacing={3} >
            <Grid item xs={6} >
                <Box style={{ margin: 10, marginTop: 10 }}>
                    <Typography className={classes.heading}>{text.title}</Typography>
                    <Typography className={classes.informationHeading} style={{ whiteSpace: 'nowrap' }}>{text.subtitle}</Typography>
                </Box>
            </Grid>
            {/* <Grid item xs={6} >
                <Box
                    sx={{
                        backgroundColor: 'green',
                        color: 'white',
                        padding: '16px',
                        textAlign: 'center',
                        height: 20
                    }}
                >
                    <Typography variant="h6">Completo</Typography>
                </Box>
            </Grid> */}
            <Grid item xs={6}>
                {open &&
                    <Box style={{ marginTop: 15 }} display="flex" justifyContent="flex-end" >
                        {
                            viewEmployeeRegistration.loading ?
                                null
                                : viewEmployeeRegistration.employeeId ?
                                <>
                                    <Button
                                        onClick={event => {
                                            event.stopPropagation();
                                            viewEmployeeRegistration.handleClickDiscard(type)
                                        }}
                                        style={{ ...styles.buttunOne, color: isUpdate ? '#484fdb' : atualization ? '#484fdb' : '#c3c3c3' }}
                                    >
                                        Descartar atualizações
                                    </Button>
                                    <Button style={{
                                        ...styles.buttonTwo,
                                        color: isUpdate ? 'white' : atualization ? 'white' : '#c3c3c3',
                                        backgroundColor: isUpdate ? '#484fdb' : atualization ? '#484fdb' : 'white',
                                    }}
                                        onClick={event => {
                                            event.stopPropagation();
                                            viewEmployeeRegistration.saveHeader(type)
                                        }}
                                        disabled={type == 'bankOfHours' ? viewEmployeeRegistration.disabledBankHours : false}
                                    >
                                        {viewEmployeeRegistration.isUpdate ? 'Salvar' : type == 'restrictions' ? 'Salvar' : 'Próximo'}
                                    </Button>
                                </>
                                : ''
                        }
                        {viewEmployeeRegistration.employeeId ?
                            <Box style={{ borderLeft: '1px solid #c3c3c3', height: '30px', marginLeft: '10px' }} />
                            : ''
                        }
                    </Box>
                }
            </Grid>
        </Grid>
    );
};

export default HeaderSummary;

const styles = {
    buttunOne: {
        backgroundColor: 'white',
        border: '1px solid #c3c3c3',
        borderRadius: 20,
        textTransform: 'none',
        width: '45%',
        height: 30,
        marginLeft: -10,
        marginRight: 10,
        fontFamily: 'montserrat',
        fontSize: 10,
        fontWeight: 'bold',
        textTransform: 'none'
    },
    buttonTwo: {
        border: '1px solid #c3c3c3',
        borderRadius: 20,
        textTransform: 'none',
        width: '20%',
        height: 30,
        marginRight: 10,
        fontFamily: 'montserrat',
        fontSize: 10,
        fontWeight: 'bold'
    }
}
